import * as React from "react";
import {cx} from "emotion";

import "./template-list.scss";

import {cs}             from "@Common/react/chain-services";
import {keyed}          from "@Common/react/keyed";
import {getNestedValue} from "@Common/utils/arr-path";
import {values}         from "@Common/utils/objects";

import {TemplateCard} from "../../../../common/template-card/template-card";

import {ChangeTemplateModal} from "./change-template-modal/change-template-modal";

export const TemplateList = ({productLabel, className, styleTemplates, product, programPrefs, store,}) => cs(
    ["styleId", (_, next) => next((() => {
        const path = ["products", product, "styles"];
        return Object.keys(
            getNestedValue(programPrefs, path) ?? {}
        )[0];
    })())],
    ["templates", ({styleId}, next) => next(styleTemplates?.[styleId]?.templates)],
    ["changeTemplateModal", ({templates}, next) => ChangeTemplateModal({
        productLabel,
        templates,
        programPrefs, store,
        next,
    })],
    ({changeTemplateModal, templates}) => (
        <div className={cx("template-list-5r1", className)}>
            <div
                className="label"
                xd-qa-type="label" xd-qa-name={"Choose your templates"}
            >
                Choose your templates
            </div>

            <div className="box">
                <div className="templates">
                    {[
                        {
                            label: "New Listing",
                            name: "newListing",
                        },
                        {
                            label: "Price Change",
                            name: "priceChange",
                        },
                        {
                            label: "Open House",
                            name: "openHouse",
                        },
                    ].map(({label, name}, i) => cs(
                        keyed(i),

                        ({}, next) => (
                            <div className="cell">
                                {next()}
                            </div>
                        ),
                        ["path", ({}, next) => next(["products", product, "templates", name])],
                        ["template", ({path}, next) => {
                            const templateId = getNestedValue(store.prefs, path) || getNestedValue(programPrefs, path);
                            return next(templates?.find((t) => t.id == templateId));
                        }],
                        ({path, template}) => TemplateCard({
                            label,
                            onChangeTemplate: () => changeTemplateModal.show({
                                triggerLabel: label,
                                path,
                            }),
                            img: template && values(template.images)[0]["url"],
                            comment: template?.description,
                        })
                    ))}
                </div>
            </div>
        </div>
    ),
);
